import React, { useState, useEffect } from 'react';
import api from '../services/api';

const PartnerManagementPage = () => {
    const [partners, setPartners] = useState([]);
    const [apiKeys, setApiKeys] = useState([]); // API Anahtarları listesi
    const [showModal, setShowModal] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [editingId, setEditingId] = useState(null);

    const [formData, setFormData] = useState({
        email: '',
        password: '',
        companyName: '',
        apiKeyId: '' // API Key seçimi için
    });

    const fetchPartners = async () => {
        try {
            const res = await api.getPartners();
            setPartners(res.data);
        } catch (error) {
            console.error("Partnerler çekilemedi", error);
        }
    };

    const fetchApiKeys = async () => {
        try {
            const res = await api.getApiKeys();
            setApiKeys(res.data);
        } catch (error) {
            console.error("API anahtarları çekilemedi", error);
        }
    };

    useEffect(() => {
        document.title = 'PayzoPay - Partner Yönetimi';
        fetchPartners();
        fetchApiKeys();
    }, []);

    const resetForm = () => {
        setFormData({ email: '', password: '', companyName: '', apiKeyId: '' });
        setIsEditMode(false);
        setEditingId(null);
    };

    const handleOpenCreate = () => {
        resetForm();
        setShowModal(true);
    };

    const handleOpenEdit = (partner) => {
        setFormData({
            email: partner.email,
            password: '', // Güvenlik gereği şifreyi boş getiriyoruz, sadece değişecekse girilir
            companyName: partner.companyName || '',
            apiKeyId: partner.apiKeyId || ''
        });
        setIsEditMode(true);
        setEditingId(partner._id);
        setShowModal(true);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            if (isEditMode) {
                await api.updatePartner(editingId, formData);
                alert('Partner güncellendi.');
            } else {
                await api.createPartner(formData);
                alert('Partner oluşturuldu.');
            }
            fetchPartners();
            setShowModal(false);
            resetForm();
        } catch (error) {
            alert('İşlem başarısız: ' + (error.response?.data?.error || error.message));
        }
    };

    const handleDelete = async (id) => {
        if (!window.confirm('Bu partneri silmek istediğinize emin misiniz?')) return;
        try {
            await api.deletePartner(id);
            fetchPartners();
        } catch (error) {
            alert('Silme başarısız.');
        }
    };

    const toggleActive = async (partner) => {
        try {
            await api.updatePartner(partner._id, { isActive: !partner.isActive });
            fetchPartners();
        } catch (error) {
            alert('Güncelleme başarısız.');
        }
    };

    const getApiKeyName = (id) => {
        const key = apiKeys.find(k => k._id === id);
        return key ? key.name : '-';
    };

    // Stiller
    const inputStyle = { width: '100%', padding: '10px', marginBottom: '15px', borderRadius: '4px', border: '1px solid var(--input-border)', backgroundColor: 'var(--input-bg)', color: 'var(--text-color)', boxSizing: 'border-box' };
    const labelStyle = { display: 'block', marginBottom: '5px', fontWeight: 'bold', color: 'var(--text-color)', fontSize: '0.9em' };
    const modalOverlayStyle = { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.7)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000 };
    const modalContentStyle = { backgroundColor: 'var(--card-bg)', padding: '25px', borderRadius: '8px', width: '400px', maxWidth: '90%', color: 'var(--text-color)' };

    return (
        <div style={{ padding: '20px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                <div>
                    <h2 style={{ color: 'var(--text-color)', margin: 0 }}>Partner Yönetimi</h2>
                    <p style={{ color: '#6c757d', margin: '5px 0 0 0', fontSize: '0.9em' }}>Sisteme entegre olan partner firmaları yönetin</p>
                </div>
                <button onClick={handleOpenCreate} style={{ padding: '10px 20px', backgroundColor: '#28a745', color: '#fff', border: 'none', borderRadius: '5px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '5px' }}>
                    <i className="fas fa-plus"></i> Yeni Partner
                </button>
            </div>

            <div style={{ backgroundColor: 'var(--card-bg)', borderRadius: '8px', overflow: 'hidden', boxShadow: 'var(--shadow)' }}>
                <table style={{ width: '100%', borderCollapse: 'separate', borderSpacing: '0', color: 'var(--text-color)' }}>
                    <thead>
                        <tr style={{ backgroundColor: 'var(--table-header-bg)', textAlign: 'left' }}>
                            <th style={{ padding: '15px' }}>Firma Adı</th>
                            <th>E-posta</th>
                            <th>Bağlı API</th>
                            <th>Durum</th>
                            <th>Kayıt Tarihi</th>
                            <th>İşlemler</th>
                        </tr>
                    </thead>
                    <tbody>
                        {partners.length === 0 ? (
                            <tr><td colSpan="5" style={{ padding: '30px', textAlign: 'center', color: '#6c757d' }}>Henüz partner eklenmemiş.</td></tr>
                        ) : (
                            partners.map(partner => (
                                <tr key={partner._id} style={{ borderBottom: '1px solid var(--border-color)', backgroundColor: 'var(--table-row-even)' }}>
                                    <td style={{ padding: '12px 15px', fontWeight: 'bold' }}>{partner.companyName || '-'}</td>
                                    <td>{partner.email}</td>
                                    <td>{getApiKeyName(partner.apiKeyId)}</td>
                                    <td>
                                        <button
                                            onClick={() => toggleActive(partner)}
                                            style={{
                                                padding: '4px 10px', borderRadius: '15px', border: 'none', cursor: 'pointer', fontSize: '0.85em',
                                                backgroundColor: partner.isActive ? '#28a745' : '#6c757d', color: '#fff'
                                            }}
                                        >
                                            {partner.isActive ? 'Aktif' : 'Pasif'}
                                        </button>
                                    </td>
                                    <td style={{ fontSize: '0.9em' }}>{new Date(partner.createdAt).toLocaleDateString()}</td>
                                    <td>
                                        <div style={{ display: 'flex', gap: '10px' }}>
                                            <button onClick={() => handleOpenEdit(partner)} style={{ color: '#007bff', background: 'none', border: 'none', cursor: 'pointer' }} title="Düzenle"><i className="fas fa-edit"></i></button>
                                            <button onClick={() => handleDelete(partner._id)} style={{ color: '#dc3545', background: 'none', border: 'none', cursor: 'pointer' }} title="Sil"><i className="fas fa-trash"></i></button>
                                        </div>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>

            {/* Modal */}
            {showModal && (
                <div style={modalOverlayStyle} onClick={() => setShowModal(false)}>
                    <div style={modalContentStyle} onClick={e => e.stopPropagation()}>
                        <h3 style={{ marginTop: 0, marginBottom: '20px' }}>{isEditMode ? 'Partner Düzenle' : 'Yeni Partner Ekle'}</h3>
                        <form onSubmit={handleSubmit}>
                            <label style={labelStyle}>Firma Adı</label>
                            <input value={formData.companyName} onChange={e => setFormData({ ...formData, companyName: e.target.value })} style={inputStyle} placeholder="Örn: ABC Teknoloji" />

                            <label style={labelStyle}>E-posta</label>
                            <input type="email" required value={formData.email} onChange={e => setFormData({ ...formData, email: e.target.value })} style={inputStyle} placeholder="partner@sirket.com" />

                            <label style={labelStyle}>Şifre {isEditMode && <span style={{ fontWeight: 'normal', fontSize: '0.8em', opacity: 0.7 }}>(Boş bırakılırsa değişmez)</span>}</label>
                            <input type="password" required={!isEditMode} value={formData.password} onChange={e => setFormData({ ...formData, password: e.target.value })} style={inputStyle} placeholder="******" />

                            <label style={labelStyle}>Bağlı API Anahtarı</label>
                            <select value={formData.apiKeyId} onChange={e => setFormData({ ...formData, apiKeyId: e.target.value })} style={inputStyle}>
                                <option value="">Seçiniz...</option>
                                {apiKeys.map(key => (
                                    <option key={key._id} value={key._id}>{key.name} ({key.apiKey.substring(0, 10)}...)</option>
                                ))}
                            </select>

                            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '20px' }}>
                                <button type="button" onClick={() => setShowModal(false)} style={{ padding: '10px 20px', border: 'none', borderRadius: '4px', cursor: 'pointer', backgroundColor: '#6c757d', color: 'white' }}>İptal</button>
                                <button type="submit" style={{ padding: '10px 20px', backgroundColor: '#007bff', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer' }}>{isEditMode ? 'Kaydet' : 'Oluştur'}</button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
};

export default PartnerManagementPage;